import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

const request = axios.create({
  baseURL: 'https://canyin.tianshiyun.xyz/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器：注入 Token
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('【请求拦截器】请求配置错误:', error)
    return Promise.reject(error)
  },
)

// 响应拦截器：统一错误处理 + Token 失效跳转登录
request.interceptors.response.use(
  (response) => {
    const { data } = response

    // code: 404 统一跳转登录页
    if (data?.code === 404) {
      ElMessage.error(data.msg || '未找到资源，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login')
      return Promise.reject(new Error(data.msg || '未找到资源'))
    }

    if (data?.code === 0 || data?.code === 200) {
      return response
    }

    // 业务层面非成功 code，统一弹框提示并 reject
    ElMessage.error(data?.msg || '请求失败')
    return Promise.reject(new Error(data?.msg || '请求失败'))
  },
  (error) => {
    // HTTP 状态码 404 也视为未登录，跳转登录页
    if (error.response?.status === 404) {
      ElMessage.error('未找到资源，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login')
      return Promise.reject(new Error('未找到资源'))
    }

    // 401 Token 失效，清除本地登录态并跳转登录页
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login')
      ElMessage.error('登录已过期，请重新登录')
      return Promise.reject(new Error('登录已过期，请重新登录'))
    }

    const message =
      error.response?.data?.msg ||
      error.response?.data?.message ||
      error.message ||
      '网络请求失败'

    ElMessage.error(message)

    return Promise.reject(error)
  },
)

export default request
